import { Css } from "~generated/css";

/**
 * A loading skeleton component that pulses.
 * @param width Defaults to "50px". "50px" is about the width of our "Included" label. We don't want it any
 * longer else our option name labels can wrap if their just long enough.
 * @param height Defaults to "16px"
 */

type LoadingBoneProps = {
  // TODO: make this more flexible by allowing it to flex grow.
  width?: string;
  height?: string;
};

/** Get it? Cause its just one piece of a <LoadingSkeleton>?!?!? */
export function LoadingBone(props: LoadingBoneProps) {
  const { width = "50px", height = "16px" } = props;
  return (
    <div
      css={
        Css.w(width).h(height).borderRadius("2px").add("animation", "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite")
          .bgGray300.$
      }
    ></div>
  );
}
